<script>
	import { postUploadData } from "../helpers.js";
	import Navbar from "../components/Navbar.svelte";
	import Footer from "../components/Footer.svelte";
	//import { page } from '$stores';
	//import { onMount } from 'svelte';

	let [targetStyle, targetAgency, targetOrganization] = ['', '', ''];
	let [targetStyleError, targetAgencyError, targetOrganizationError] = ['', '', ''];

	const ecpr_style_options = [
		{ id: 1, name: "DIR-DLSE eCPR Downloads" },
		{ id: 2, name: 'ADP Payroll' },
		{ id: 3, name: 'DLSE A-1-131' },
		{ id: 4, name: 'Generic Weekly PWC Report' },
		{ id: 5, name: "Not listed (upload now & contact PADG)" }
	];

	const ecpr_styles = ["DIR-DLSE eCPR Downloads", 'ADP Payroll', 'DLSE A-1-131', 'Generic Weekly PWC Report', 'Not listed (upload now & contact PADG)']
	//const ecpr_styles = [
	//	get_value_by_id(ecpr_style_options, 1, 'name'),
	//	get_value_by_id(ecpr_style_options, 2, 'name'),
	//	get_value_by_id(ecpr_style_options, 3, 'name'),
	//	get_value_by_id(ecpr_style_options, 4, 'name'),
	//	get_value_by_id(ecpr_style_options, 5, 'name'),
	//]
	//'LCPcertified', 'Payroll4Const', 'Intuit', 

	//for generic weekly, show customer sample parsed data to accept or change to no listed

	let otherError = '';
	let searchForm;

	let fileInput = null;
	let fileInput_m = null;
  	//let formData;

	const fileType = ".pdf"

	let submitted = false;

	//onMount(() => {
    //	console.log('serverData', $page.data.serverData);
  	//});

	function handleSubmit() {
		// convert form to json
		let formData = new FormData(searchForm)
		var searchObj = {};

		checkboxToIntParams.forEach((key) => searchObj[key] = 0) //defaults
		// searchObj['all_industry_summary_block'] = false; // default

		formData.forEach((value, key) => {
			if(checkboxToIntParams.includes(key)) {
				searchObj[key] = value === 'on' ? 1 : 0; 
			} else {
				searchObj[key] = value;
			}
		});
		submitted = true;
	}

	async function postFormData_on_desktop_click(event) {
		event.preventDefault()
		const apiEndpoint = 'db-core/upload'

		let target_style_index1 = ecpr_style_options.findIndex(x => x.name === targetStyle) + 1;
		let target_style_index1_str =  target_style_index1.toString()
		
		let abbrev_targetOrganization1 = targetOrganization.match(/\b([A-Z])/g).join('');
		console.log("organization abbrev: ", abbrev_targetOrganization1)
		let abbrev_targetOrganization2 = targetOrganization.match(/\b([a-zA-Z])/g).join('').toUpperCase();
		console.log("organization abbrev: ", abbrev_targetOrganization2)
		console.log("organization full: ", targetOrganization)
		
		//let test_string = $page.data.serverData.user.username
		//console.log(test_string, "test")

		targetAgency = "WDL"
		console.log("agency: ", targetAgency)
		postUploadData(apiEndpoint, fileInput, target_style_index1_str, abbrev_targetOrganization2, targetAgency, fileType, targetOrganization)
	}

	async function postFormData_on_mobile_click(event) {
		event.preventDefault()
		const  apiEndpoint = 'db-core/upload'
		let abbrev_targetOrganization = targetOrganization.match(/\b([a-zA-Z])/g).join('').toUpperCase();
		let target_style_index2 = string(ecpr_style_options.findIndex(x => x.name === targetStyle) + 1);
		let target_style_index2_str =  target_style_index2.toString()
		postUploadData(apiEndpoint, fileInput_m, target_style_index2_str, abbrev_targetOrganization, targetAgency, fileType)
	}

</script>

<main class=background>
	<Navbar/>
	<div class="flex flex-col space-y-4 mt-10 items-center lg:flex-row lg:justify-center">
		<div class="mx-2 !mb-4 px-10 py-12 max-w-4xl w-full flex-1 card">
			
			
			<!-- Use hidden to preserve form state instead of discarding -->

			<!--Desktop -->
			<div class="hidden md:block"> <!-- Cheap way out, especially since layout change on desktop-->
				<p class="text-2xl font-semibold text-blue-900 mb-8">Add Investigation PDF eCPRs to your db Core</p>
				<p class="text-red-500 {otherError === '' ? '' : 'text-xl pb-5'}">{otherError}</p>
				

				<!--
				{#if form_upoaded?.success}
					<h2>File Uploaded!</h2>
				{/if}
				-->
				
				<form method="POST" class="h-full relative" enctype="multipart/form-data" bind:this={fileInput} on:submit|preventDefault={postFormData_on_desktop_click} >
					
					<div class="flex flex-col space-y-4 text-xl">

						<div class='form'>
							<input type='file' id='file-upload' name='file_upload' actions='?/upload' accept='application/pdf'  />
						</div>

						<div class='input w-full'>
							<div class="relative">
								<input id="target-organization" name="target_organization" bind:value={targetOrganization} placeholder="Target Organization (Optional)" class="peer z-20 placeholder:text-transparent {targetOrganizationError === '' ? '' : 'border-red-600'}"/>
								<label for="target-organization" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Name of Contractor or Subcontractor</label>
							</div>
							<p class="error-text {targetOrganizationError === '' ? 'hidden' : ''}">{targetOrganizationError}</p>
						</div>

						<div class="flex space-x-4">
							<div class='input w-1/2'>
								<div class="relative">
									<select id="target-style" name="target_style" bind:value={targetStyle} class="input-field mt-4 w-full {targetStyleError === '' ? '' : 'border-red-600'}">
										<option value="">Select a Style</option>
										{#each ecpr_styles as style }
										<option value={style}>{style.replaceAll("_", " ")}</option>
										{/each}
									</select>
									<label for="target-style" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">Payroll Form Style</label>
								</div>
								<p class='error-text {targetStyleError === '' ? 'hidden' : ''}'>{targetStyleError}</p>
							</div>
						</div>

						<button type='submit'
							class="w-4/12 pl-0 pb-2 pt-1 mt-4 text-xl rounded-md bg-blue-500 disabled:bg-blue-300 disabled:text-white hover:bg-blue-700 cursor-pointer disabled:cursor-wait text-white font-semibold border-none shadow-sm">
							Upload
						</button>

						
					

						<br> <!-- Spacing -->

					</div>
				</form>

			</div>

			<!--Mobile -->
			<div class="block md:hidden"> 
				<p class="text-2xl font-semibold text-blue-900 mb-8">Add Investigation PDF eCPRs to your db Core</p>
				<p class="text-red-500 {otherError === '' ? '' : 'text-xl pb-5'}">{otherError}</p>
				
				<!--
				{#if form_upoaded?.success}
					<h2>File Uploaded!</h2>
				{/if}
				-->

				<form method="POST" class="h-full relative" enctype="multipart/form-data" bind:this={fileInput_m} on:submit|preventDefault={postFormData_on_mobile_click} >
					
					<div class="flex flex-col space-y-4 text-xl">

						<div class='form'>
							<input type='file' id='file-upload' name='file_upload' actions='?/upload' accept='application/pdf' />
						</div>
						
						<div class='input'>
							<div class="relative">
								<input id="target-organization" name="target_organization" bind:value={targetOrganization} placeholder="Target Organization (Optional)" class="peer z-20 placeholder:text-transparent {targetOrganizationError === '' ? '' : 'border-red-600'}"/>
								<label for="target-organization" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Name of Contractor</label>
							</div>
							<p class="error-text {targetOrganizationError === '' ? 'hidden' : ''}">{targetOrganizationError}</p>
						</div>


						<div class='input'>
							<div class="relative">
								<select id="target-style-mobile" name="target_style" bind:value={targetStyle} class="input-field mt-4 w-full {targetStyleError === '' ? '' : 'border-red-600'}">
									<option value="">Select a Style</option>
									{#each ecpr_styles as style}
									<option value={style}>{style.replaceAll("_", " ")}</option>
									{/each}
								</select>
								<label for="target-style-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">Payroll Form Style</label>
							</div>
							<p class='error-text {targetStyleError === '' ? 'hidden' : ''}'>{targetStyleError}</p>
						</div>

						
						<button type='submit'
							class="w-4/12 pl-0 pb-2 pt-1 mt-4 text-xl rounded-md bg-blue-500 disabled:bg-blue-300 disabled:text-white hover:bg-blue-700 cursor-pointer disabled:cursor-wait text-white font-semibold border-none shadow-sm">
							Upload
						</button>

						<br> <!-- Spacing -->

					</div>	
				</form>
			</div>

		</div>
	</div>
	<Footer/>
</main>

<style>
	main.background { 
		background-color:theme("colors.gray.100");
	}
	.input-field {
		@apply rounded-md shadow-sm font-thin py-1 px-2;
	}
</style>